import { UUID } from "crypto";
import { ChangeEvent, Dispatch, SetStateAction, useEffect, useState } from "react";
import { getNextMonthLastDate, getDateString, getFutureDate, getTimeString, getUTC } from "../../appFunctions";
import dayjs, { Dayjs } from "dayjs";
import appError from "../../appError";
import axios from "axios";
import { BASE_URL, BLACK, PRIMARY, STATUS, WHITE } from "../../appConstants";
import toast from "react-hot-toast";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TimeSlotInput from "../commonComponents/TimeSlotInput";
import { Button, Input } from "@mui/joy";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";






interface AccountInfo {
    marketplaceStringId: string;
    id: string;
    type: string;
    name: string;
    validPaymentMethod: boolean;
}

interface ProfileObject {
    profileId: number;
    countryCode: string;
    currencyCode: string;
    dailyBudget: number;
    timezone: string;
    accountInfo: AccountInfo;
}

type FileDetailObj = {
    file_detail_id: UUID,
    start_date: string,
    end_date: string,
    schedule_date: string,
    schedule_time: string,
    series_id: string,
    weekday: number,
    days: number[],
    schedule_status: string,
    schedule_name: string,
    file_id: string,
    emails: string,
    created_by: UUID,
    updated_by: UUID,
    created_time_stamp: string,
    updated_time_stamp: string,
    file_name: string,
    brand_id: string,
    status: string,
    type: string,
    recurring_type: string,
    time_slots: string[],
    profile_obj: ProfileObject

}



type TimeSlotObject = {
    type: string,
    week_days: (number | undefined)[],
    time_slots: string[]
}

type StateObject = {
    start_time_stamp: Date | null,
    end_time_stamp: Date | null,
    time_slots: TimeSlotObject,
    emails: string
}
type HourAndMin = {
    hour: string;
    min: string;
}


const EditOneTimeSchedule: React.FC<{ fetchBulkFileDetail: () => void, fileDetail: FileDetailObj, closeViewHandler: () => void }> = ({ fileDetail, fetchBulkFileDetail, closeViewHandler }) => {
    const navigate = useNavigate();
    const brandId = useSelector((state: any) => state.appData.brand_id);
    const {
        stage,
        brand_id,
        platform_id,
        onboarding_type,
        brand_power_bi_dashboard_id,
        brand_power_bi_dashboard_type_id,
      } = useSelector((state: any) => state.appData);
    const [loading, setLoading] = useState<boolean>(false);
    const [oneTimeHourAndMin, setOneTimeHourAndMin] = useState<HourAndMin>({} as HourAndMin);
    const [emails, setEmails] = useState<string>("");
    const [state, setState] = useState<StateObject>({
        start_time_stamp: new Date(fileDetail?.start_date),
        end_time_stamp: new Date(fileDetail?.end_date),
        time_slots: {
            type: '',
            week_days: [
                getUTC(new Date()).getDay()
            ],
            time_slots: []
        },
        emails: ""
    });


    useEffect(() => {
        const [hh, mm, ss] = fileDetail?.time_slots[0]?.split(":");
        setOneTimeHourAndMin({
            hour: hh,
            min: mm
        })
        setEmails(fileDetail?.emails);
        setState({
            start_time_stamp: new Date(fileDetail?.start_date),
            end_time_stamp: new Date(fileDetail?.end_date),
            time_slots: {
                type: fileDetail?.type,
                week_days: fileDetail?.days,
                time_slots: fileDetail?.time_slots
            },
            emails: fileDetail?.emails
        })
    }, [])


    const setHourAndMinHandler = (unit: string, value: string) => {
     
        setOneTimeHourAndMin(prevState => ({
            ...prevState,
            [unit]: value
        }))
    }

    const onInputChangeHandler = ({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
        setEmails(value);
    }

    const onDateChangeHandler = (dateObje: Dayjs | null) => {
        const day = dateObje?.day();
        const date = dateObje?.date();
        const month = dateObje?.month();
        const year = dateObje?.year();

        const time_stamp = new Date(`${year}-${month as number + 1}-${date}`);

        const time_slots: TimeSlotObject = {} as TimeSlotObject;
        time_slots.week_days = [day];
        // time_slots.type = "one_time";
        setState(prevState => ({
            ...prevState,
            time_slots,
            start_time_stamp: time_stamp,
            end_time_stamp: time_stamp
        }));
    }

    const onSaveClickHandler = async () => {


        if (!(oneTimeHourAndMin.hour && oneTimeHourAndMin.min)) {
            appError("Please select time slot.");
            return;
        }


        if (!emails.length) {
            appError("Please provide email.");
            return
        }

        const { schedule_name, type, file_name, file_id, series_id, profile_obj } = fileDetail;
        const { start_time_stamp, end_time_stamp, time_slots: { week_days } } = state;

        const obj = {
            schedule_name,
            file_name,
            file_id,
            start_date: getDateString(start_time_stamp),
            end_date: getDateString(end_time_stamp),
            today_current_date: getDateString(new Date()),
            today_current_time: getTimeString(new Date()),
            emails: emails,
            time_slots: {
                recurring_type: "one_time",
                type,
                time_slots: [`${oneTimeHourAndMin.hour}:${oneTimeHourAndMin.min}`],
                week_days
            },
            series_id,
            profile_obj
        }

        let current_date_time_plus_one_hour = new Date(`${getDateString(new Date())}T${getTimeString(new Date())}`);
        current_date_time_plus_one_hour.setHours(current_date_time_plus_one_hour.getHours() + 1);
        let schedule_date_time = new Date(`${obj.start_date}T${obj.time_slots?.time_slots[0]}`);


        if (!(schedule_date_time > current_date_time_plus_one_hour)) {
            appError("Please choose a time at least 1 hour from the current time.");
            return;
        }

        try {
            setLoading(true);
            const token = localStorage.getItem("token");

            const res = await axios.post(`${BASE_URL}brand/bulk/fileDetail/updateBulkFileSchedule?brand_id=${brandId}&platform_id=${platform_id}&dashboard_type_id=${brand_power_bi_dashboard_type_id}`,
                obj,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            );

            const { message, file_detail_id } = res?.data?.data;
            toast.success(message);
            fetchBulkFileDetail();
            closeViewHandler();
            navigate("/bulkUpload/allFiles");
            // setRefresh(prevState => !prevState);
            //setOpenModal(false);
        } catch (error) {
            appError(error);
        } finally {
            setLoading(false);
        }

    }

    const statusMap = new Map<string, string>([
        ["ACTIVE", "Active"],
        ["PAUSED", "Paused"],
        ["CANCELLED", "Cancelled"]
    ]);


    const statusColorMap = new Map<string, string>([
        ["ACTIVE", STATUS.S_Green],
        ["PAUSED", "#EB730A"],
        ["CANCELLED", STATUS.S_Red]
    ]);


    const statusBackgroundColorMap = new Map<string, string>([
        ["ACTIVE", STATUS.S_Green10],
        ["PAUSED", "#FFF2C7"],
        ["CANCELLED", STATUS.S_Red10]
    ]);

    return (
        <>
            <div className="flex"  >
                <div style={{ fontSize: 16, fontWeight: 600, lineHeight: "24px" }} >
                    Sponsored Ads Bulk File
                </div>
                <div className="px-2 py-1 w-fit ml-2" style={{ height: 24, color: statusColorMap.get(fileDetail?.status), backgroundColor: statusBackgroundColorMap.get(fileDetail?.status), borderRadius: 4, fontSize: 10, fontWeight: 500 }} >
                    {
                        statusMap.get(fileDetail?.status)
                    }
                </div>
            </div>
            <div className="flex justify-between mt-6">
                <div>
                    <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Date</div>
                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                        <DesktopDatePicker
                            minDate={dayjs(new Date())}
                            maxDate={dayjs(getNextMonthLastDate())}
                            // defaultValue={dayjs(new Date())}
                            value={dayjs(new Date(fileDetail?.end_date))}
                            onChange={onDateChangeHandler}
                            slots={{
                                openPickerIcon: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M6.6665 11.6186C6.46248 11.6186 6.28859 11.5467 6.14484 11.4031C6.00123 11.2594 5.92942 11.0855 5.92942 10.8815C5.92942 10.6774 6.00123 10.5036 6.14484 10.3598C6.28859 10.2161 6.46248 10.1442 6.6665 10.1442C6.87053 10.1442 7.04442 10.2161 7.18817 10.3598C7.33178 10.5036 7.40359 10.6774 7.40359 10.8815C7.40359 11.0855 7.33178 11.2594 7.18817 11.4031C7.04442 11.5467 6.87053 11.6186 6.6665 11.6186ZM9.99984 11.6186C9.79581 11.6186 9.62192 11.5467 9.47817 11.4031C9.33456 11.2594 9.26275 11.0855 9.26275 10.8815C9.26275 10.6774 9.33456 10.5036 9.47817 10.3598C9.62192 10.2161 9.79581 10.1442 9.99984 10.1442C10.2039 10.1442 10.3778 10.2161 10.5215 10.3598C10.6651 10.5036 10.7369 10.6774 10.7369 10.8815C10.7369 11.0855 10.6651 11.2594 10.5215 11.4031C10.3778 11.5467 10.2039 11.6186 9.99984 11.6186ZM13.3332 11.6186C13.1291 11.6186 12.9553 11.5467 12.8115 11.4031C12.6679 11.2594 12.5961 11.0855 12.5961 10.8815C12.5961 10.6774 12.6679 10.5036 12.8115 10.3598C12.9553 10.2161 13.1291 10.1442 13.3332 10.1442C13.5372 10.1442 13.7111 10.2161 13.8548 10.3598C13.9984 10.5036 14.0703 10.6774 14.0703 10.8815C14.0703 11.0855 13.9984 11.2594 13.8548 11.4031C13.7111 11.5467 13.5372 11.6186 13.3332 11.6186ZM4.42296 17.9167C4.00199 17.9167 3.64567 17.7708 3.354 17.4792C3.06234 17.1875 2.9165 16.8312 2.9165 16.4102V5.25647C2.9165 4.8355 3.06234 4.47918 3.354 4.18751C3.64567 3.89585 4.00199 3.75001 4.42296 3.75001H5.57671V2.62814C5.57671 2.4455 5.63789 2.293 5.76025 2.17064C5.88261 2.04842 6.03511 1.9873 6.21775 1.9873C6.40053 1.9873 6.55303 2.04842 6.67525 2.17064C6.79762 2.293 6.8588 2.4455 6.8588 2.62814V3.75001H13.173V2.6123C13.173 2.43494 13.2328 2.2864 13.3523 2.16668C13.4721 2.0471 13.6206 1.9873 13.798 1.9873C13.9753 1.9873 14.1238 2.0471 14.2434 2.16668C14.3631 2.2864 14.423 2.43494 14.423 2.6123V3.75001H15.5767C15.9977 3.75001 16.354 3.89585 16.6457 4.18751C16.9373 4.47918 17.0832 4.8355 17.0832 5.25647V16.4102C17.0832 16.8312 16.9373 17.1875 16.6457 17.4792C16.354 17.7708 15.9977 17.9167 15.5767 17.9167H4.42296ZM4.42296 16.6667H15.5767C15.6409 16.6667 15.6996 16.6399 15.753 16.5865C15.8064 16.5331 15.8332 16.4744 15.8332 16.4102V8.5898H4.1665V16.4102C4.1665 16.4744 4.19324 16.5331 4.24671 16.5865C4.30005 16.6399 4.3588 16.6667 4.42296 16.6667ZM4.1665 7.3398H15.8332V5.25647C15.8332 5.1923 15.8064 5.13355 15.753 5.08022C15.6996 5.02675 15.6409 5.00001 15.5767 5.00001H4.42296C4.3588 5.00001 4.30005 5.02675 4.24671 5.08022C4.19324 5.13355 4.1665 5.1923 4.1665 5.25647V7.3398Z" fill="#1C1C1C" fill-opacity="0.4" />
                                </svg>
                            }}
                            format="DD-MMM-YY"
                            slotProps={{
                                textField: {
                                    // placeholder: "Choose date",
                                    sx: {

                                        width: "340px",
                                        '& .MuiInputBase-root': {
                                            height: "52px"
                                        },
                                        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                            border: `1px solid ${BLACK.B_10}`,
                                            borderRadius: '8px'
                                        },

                                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            border: `1px solid ${BLACK.B_10}`
                                        },
                                        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                            border: `1px solid ${BLACK.B_10}`
                                        }
                                    }
                                }
                            }}
                        />
                    </LocalizationProvider>
                </div>
                <div>
                    <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Time Slot</div>
                    <TimeSlotInput setHourAndMinHandler={setHourAndMinHandler} oneTimeHourAndMin={oneTimeHourAndMin} />

                </div>

            </div>
            <div className="mt-6" >
                <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Email ID</div>
                <Input
                    placeholder="Enter your email ID for notification"
                    value={emails}
                    sx={{
                        "--Input-focusedThickness": "0px",
                        width: "708px",
                        height: "52px",
                        backgroundColor: WHITE.W_100,
                        fontSize: 14,
                        fontWeight: 400,
                        lineHeight: "20px",
                        border: `1px solid ${BLACK.B_10}`
                    }}
                    name="company_name"
                    onChange={onInputChangeHandler}
                />
            </div>


            <div className="flex flex-row justify-between mt-10">
                <Button color="neutral"
                    sx={{
                        height: "48px",
                        width: "340px",
                        backgroundColor: BLACK.B_5,
                        color: BLACK.B_100,
                        ":hover": {
                            backgroundColor: BLACK.B_20,
                        }
                    }}
                    onClick={closeViewHandler}
                >Cancel</Button>
                <Button
                    loading={loading}
                    onClick={onSaveClickHandler}
                    // endDecorator={
                    //     <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                    //         <path d="M17.8172 10.4425L12.1922 16.0675C12.0749 16.1848 11.9159 16.2507 11.75 16.2507C11.5841 16.2507 11.4251 16.1848 11.3078 16.0675C11.1905 15.9503 11.1247 15.7912 11.1247 15.6253C11.1247 15.4595 11.1905 15.3004 11.3078 15.1832L15.8664 10.6253H3.625C3.45924 10.6253 3.30027 10.5595 3.18306 10.4423C3.06585 10.3251 3 10.1661 3 10.0003C3 9.83459 3.06585 9.67562 3.18306 9.55841C3.30027 9.4412 3.45924 9.37535 3.625 9.37535H15.8664L11.3078 4.81753C11.1905 4.70026 11.1247 4.5412 11.1247 4.37535C11.1247 4.2095 11.1905 4.05044 11.3078 3.93316C11.4251 3.81588 11.5841 3.75 11.75 3.75C11.9159 3.75 12.0749 3.81588 12.1922 3.93316L17.8172 9.55816C17.8753 9.61621 17.9214 9.68514 17.9529 9.76101C17.9843 9.83688 18.0005 9.91821 18.0005 10.0003C18.0005 10.0825 17.9843 10.1638 17.9529 10.2397C17.9214 10.3156 17.8753 10.3845 17.8172 10.4425Z" fill="white" />
                    //     </svg>
                    // }
                    sx={{
                        height: "48px",
                        width: "340px",
                        backgroundColor: PRIMARY.P_BLue,
                    }}
                >Save</Button>
            </div>

        </>
    )
}



export default EditOneTimeSchedule;

